import React from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import { t } from '../common/Translate';

const SelectCheckboxes = (props) => {
  const { options, placeholder, onChangeCallback, allOption, value, inputValue, onInputChangeCallBack } = props;
  const hasSelectedFilter = value?.length > 0;

  const countValue = () => value.filter((i) => i.value !== '*');

  const customPlaceholder = (
    <>
      <div className={hasSelectedFilter ? 'position-filters' : ''}>
        <span>{placeholder}</span>
      </div>

      {hasSelectedFilter && (
        <div>
          <small>
            {countValue().length} {(value.length === 1 && t('selected_filter')) || t('selected_filters')}
          </small>
        </div>
      )}
    </>
  );

  const customStyles = {
    control: (base) => ({
      ...base,
      background: '#f4f4f4',
      borderColor: '#f4f4f4',
      width: 200,
      marginBottom: hasSelectedFilter ? '-15px' : '-8px',
    }),
    placeholder: (defaultStyles) => ({
      ...defaultStyles,
      color: '#495057',
    }),
  };

  const Option = (optionProps) => {
    const { isSelected, label } = optionProps;
    return (
      <div>
        <components.Option {...optionProps}>
          <input type="checkbox" checked={isSelected} onChange={() => null} />
          {'  '}
          <span className={isSelected ? 'text-white ml-1' : 'text-dark ml-1'}>{label}</span>
        </components.Option>
      </div>
    );
  };

  return (
    <Select
      styles={customStyles}
      options={[allOption, ...options]}
      onChange={(selected) => {
        if (selected !== null && selected.length > 0) {
          if (selected[selected.length - 1].value === allOption.value) {
            return onChangeCallback([allOption, ...options]);
          }
          if (selected[selected.length - 1].value !== allOption.value && selected.length === options.length) {
            return onChangeCallback([]);
          }
        }
        return onChangeCallback(selected);
      }}
      closeMenuOnSelect={false}
      isMulti
      hideSelectedOptions={false}
      backspaceRemovesValue={false}
      placeholder={customPlaceholder}
      controlShouldRenderValue={false}
      components={{ Option }}
      value={value}
      className={hasSelectedFilter ? 'mb--3' : ''}
      inputValue={inputValue}
      blurInputOnSelect={false} // set by default, but to be sure
      onInputChange={(string, { action }) => {
        if (action !== 'set-value') onInputChangeCallBack(string);
      }} // the function to handle our search input
    />
  );
};

SelectCheckboxes.propTypes = {
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]).isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]).isRequired,
  onChangeCallback: PropTypes.func.isRequired,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  inputValue: PropTypes.string,
  onInputChangeCallBack: PropTypes.func.isRequired,
};

SelectCheckboxes.defaultProps = {
  allOption: {
    label: t('select_all'),
    value: '*',
  },
  inputValue: '',
};

export default SelectCheckboxes;
